<template>
  <div>
    <TheHeader />
    
    <div id="main">
      <TheSidebar />

      <transition
        name="route"
        mode="out-in"
      >
        <router-view id="content" />
      </transition>
    </div>

    <Modal />

    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "./header"
import TheSidebar from "./aside/"
import TheFooter from "./footer"
import Modal from "./modal"

export default {
  name: "Layout",
    components: {
        TheHeader,
        TheSidebar,
        TheFooter,
        Modal,
    }
}
</script>

<style>
  .el-input__inner:focus, .el-textarea__inner:focus{
    border: 2px solid #409EFF!important;
  }
</style>

<style lang="scss" scoped>
#main {
    display: flex;
    margin-top: 75px;
    min-height: calc(100vh - 64px - 123px);
}


#content {
    padding: 0 20px;
    flex: 1;
    max-width: calc(100vw - 270px);
}

@media (max-width: 768px) {
    #content {
        margin: 0;
        width: 100%;
        max-width: 100%;
        padding: 0 10px;
    }
}

.route-enter-active {
  animation: slide .3s ease-out;
}
.route-leave-active {
  animation: slide .3s ease-out reverse;
}

@keyframes slide {
  0% {
    opacity: 0;
    transform: translateX(30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>